module.exports = __webpack_public_path__ + "media/images/footer_page/about/about-step1-46d57a5acbb7453a423bc9b90d340e9b.svg";